import {
  Box,
  Button,
  Container,
  FormControlLabel,
  Paper,
  Typography,
  Slider,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormGroup,
} from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import brand from "../../../Assets/Services/Flight/flight.svg";
import before6am from "../../../Assets/Services/Flight/sun.svg";
import partlyCloudy from "../../../Assets/Services/Flight/partly_cloudy.svg";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import NightsStayOutlinedIcon from "@mui/icons-material/NightsStayOutlined";
import { Grid } from "@material-ui/core";
import EastIcon from "@mui/icons-material/East";
import Line from "../../../Assets/Services/Flight/Line.svg";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import FlightIcon from "@mui/icons-material/Flight";
import FlightClassIcon from "@mui/icons-material/FlightClass";
import { useLocation, useNavigate } from "react-router-dom";

function MultiCity() {
  const navigate = useNavigate();
  const location = useLocation();

  // const flightsData = location.state || [];
  const { flightsData, searchDetails } = location.state || {};

  console.log("searchDetails", searchDetails);
  const flights = flightsData?.Response?.Results || [];

  const [priceRange, setPriceRange] = useState([0, 50000]);

  const handlePriceChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  // Sample flight details array
  const flightDetailsArray = [
    {
      airline: "Air India",
      flightCode: "AI - 598",
      departureTime: "15:22",
      departureLocation: "Mumbai",
      arrivalTime: "23:07",
      arrivalLocation: "Delhi",
      duration: "7 Hr 45 Min",
      price: 4000,
      discountPrice: 3500,
      seatsLeft: 9,
    },
    {
      airline: "Air India",
      flightCode: "AI - 598",
      departureTime: "15:22",
      departureLocation: "Mumbai",
      arrivalTime: "23:07",
      arrivalLocation: "Delhi",
      duration: "7 Hr 45 Min",
      price: 4000,
      discountPrice: 3500,
      seatsLeft: 9,
    },
    {
      airline: "Air India",
      flightCode: "AI - 598",
      departureTime: "15:22",
      departureLocation: "Mumbai",
      arrivalTime: "23:07",
      arrivalLocation: "Delhi",
      duration: "7 Hr 45 Min",
      price: 4000,
      discountPrice: 3500,
      seatsLeft: 9,
    },
    {
      airline: "Air India",
      flightCode: "AI - 598",
      departureTime: "15:22",
      departureLocation: "Mumbai",
      arrivalTime: "23:07",
      arrivalLocation: "Delhi",
      duration: "7 Hr 45 Min",
      price: 4000,
      discountPrice: 3500,
      seatsLeft: 9,
    },
    {
      airline: "Air India",
      flightCode: "AI - 598",
      departureTime: "15:22",
      departureLocation: "Mumbai",
      arrivalTime: "23:07",
      arrivalLocation: "Delhi",
      duration: "7 Hr 45 Min",
      price: 4000,
      discountPrice: 3500,
      seatsLeft: 9,
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ marginTop: "8%" }}>
      <Typography>Service &gt; Flight Booking</Typography>

      <Paper
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          mt: 2,
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 4,
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Open Sans",
                fontWeight: 600,
              }}
            >
              {searchDetails.from}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <EastIcon />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Open Sans",
                fontWeight: 600,
              }}
            >
              {searchDetails.to}
            </Typography>
          </Box>
          <img src={Line} alt="Line" />

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: "Open Sans",
                opacity: 0.8,
              }}
            >
              Departure
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: "Open Sans",
                fontWeight: 600,
              }}
            >
              {new Intl.DateTimeFormat("en-US", {
                day: "2-digit",
                month: "short",
                year: "2-digit",
                weekday: "long",
              }).format(new Date(searchDetails.departDate))}
            </Typography>
          </Box>
          <img src={Line} alt="Line" />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: "Open Sans",
                opacity: 0.8,
              }}
            >
              Travellers
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Open Sans",
                fontWeight: 600,
              }}
            >
              {/* 01 */}
              {searchDetails.travelers}
            </Typography>
          </Box>
          <img src={Line} alt="Line" />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: "Open Sans",
                opacity: 0.8,
              }}
            >
              Travel Class
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Open Sans",
                fontWeight: 600,
              }}
            >
              {/* Economy */}
              {searchDetails.travelClass}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button
            onClick={() => navigate(-1)}
            sx={{
              background: "#027BFE",
              color: "white",
              textTransform: "none",
              px: 2,
              borderRadius: "10px",
            }}
          >
            Modify Search
          </Button>
        </Box>
      </Paper>

      <Box mt={2}>
        <Grid container spacing={6}>
          {/* Filter */}
          <Grid item xs={12} md={3}>
            <Box>
              <Typography>Filters</Typography>

              <Box
                sx={{
                  mt: 2,
                  ml: 2,
                  mb: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    fontFamily: "Open Sans",
                  }}
                >
                  Flight Leg
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mt: 2,
                    gap: 1,
                  }}
                >
                  <Button variant="contained">1</Button>
                  <Button variant="contained">2</Button>
                </Box>
              </Box>

              {/* Price */}
              <Accordion
                defaultExpanded
                sx={{ boxShadow: "none", border: "none" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Price</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Slider
                    getAriaLabel={() => "Price range"}
                    value={priceRange}
                    onChange={handlePriceChange}
                    valueLabelDisplay="auto"
                    min={0}
                    max={50000}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Typography>₹{priceRange[0]}</Typography>
                    <Typography>₹{priceRange[1]}</Typography>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Divider />

              {/* Departure Time */}
              <Accordion
                defaultExpanded
                sx={{ boxShadow: "none", border: "none" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Departure Time</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={before6am}
                        alt="before6am"
                        style={{ height: "20px" }}
                      />
                      <Typography sx={{ fontSize: "10px" }}>
                        Before 6 AM
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Box>
                        <WbSunnyOutlinedIcon sx={{ fontSize: "20px" }} />
                      </Box>
                      <Typography sx={{ fontSize: "10px" }}>
                        6 AM - 12 PM
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={partlyCloudy}
                        alt="partlyCloudy"
                        style={{ height: "20px" }}
                      />
                      <Typography sx={{ fontSize: "10px" }}>
                        12 PM - 6 PM
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Box>
                        <NightsStayOutlinedIcon sx={{ fontSize: "20px" }} />
                      </Box>
                      <Typography sx={{ fontSize: "10px" }}>
                        After 6 PM
                      </Typography>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Divider />
              {/* Airlines Time */}
              <Accordion
                defaultExpanded
                sx={{ boxShadow: "none", border: "none" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Airlines</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox />} label="Emirated" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Fly Dubai"
                    />
                    <FormControlLabel control={<Checkbox />} label="Qatar" />
                    <FormControlLabel control={<Checkbox />} label="Etihad" />
                  </FormGroup>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>

          {/* Flight Details */}
          <Grid item xs={12} md={9}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <Box>
                  <Button variant="contained">1</Button>
                </Box>
                <Box>
                  <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                    <Typography>Mumbai</Typography>
                    <EastIcon />
                    <Typography>New Delhi</Typography>
                  </Box>
                  <Box>
                    <Typography mt={-1}>
                      <span style={{ fontSize: "12px", fontWeight: 600 }}>
                        14
                      </span>
                      <span style={{ fontSize: "12px" }}> Nov, 24, Sunday</span>
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "end",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: 300,
                    fontFamily: "Open Sans",
                  }}
                >
                  Showing 59 of 59 Flights found
                </Typography>
              </Box>
            </Box>
            {flightDetailsArray.map((flight, index) => (
              <Box
                key={index}
                sx={{
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    p: 2,
                    borderRadius: "20px 20px 0px 0px",
                    background: "#E8F2FD",
                  }}
                >
                  <DinnerDiningIcon sx={{ fontSize: "14px", mt: 0.3 }} />
                  <Typography sx={{ ml: 1, fontSize: "14px" }}>
                    Free Meal
                  </Typography>
                </Box>
                <Paper
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "0px 0px 20px 20px",
                    mt: -1,
                  }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 3,
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Box>
                        <img
                          src={brand}
                          alt="brand"
                          style={{ width: "50px", height: "50px" }}
                        />
                      </Box>
                      <Box
                        sx={{ display: "flex", flexDirection: "column", ml: 1 }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            fontFamily: "Open Sans",
                          }}
                        >
                          {flight.airline}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 300,
                            fontFamily: "Open Sans",
                          }}
                        >
                          {flight.flightCode}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: 700,
                          fontFamily: "Open Sans",
                        }}
                      >
                        {flight.departureTime}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 300,
                          fontFamily: "Open Sans",
                        }}
                      >
                        {flight.departureLocation}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          color: "#027BFE",
                        }}
                      >
                        {flight.duration}
                      </Typography>
                      <FlightIcon
                        sx={{ rotate: "90deg", color: "#027BFE", ml: 0.5 }}
                      />
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: 700,
                          fontFamily: "Open Sans",
                        }}
                      >
                        {flight.arrivalTime}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 300,
                          fontFamily: "Open Sans",
                        }}
                      >
                        {flight.arrivalLocation}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <FlightClassIcon
                        sx={{
                          color: "#027BFE",
                          ml: 0.5,
                          transform: "scaleX(-1)",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                          color: "#027BFE",
                        }}
                      >
                        {flight.seatsLeft} Left
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "end",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 300,
                          fontFamily: "Open Sans",
                          color: "#FF0000",
                          textDecoration: "line-through",
                        }}
                      >
                        ₹ {flight.price}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: 600,
                          fontFamily: "Open Sans",
                        }}
                      >
                        ₹ {flight.discountPrice}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Button
                        sx={{
                          background: "#027BFE",
                          borderRadius: "10px",
                          color: "white",
                          textTransform: "none",
                          px: 3,
                        }}
                      >
                        View fare
                      </Button>
                      <Button
                        variant="text"
                        sx={{
                          color: "#027BFE",
                          textTransform: "none",
                          mt: 0.5,
                          ":hover": {
                            background: "white",
                          },
                        }}
                      >
                        + Flight Details
                      </Button>
                    </Box>
                  </Box>
                  <Divider />
                  <Box
                    sx={{
                      px: 1,
                      py: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#027BFE",
                        fontSize: "12px",
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                      }}
                    >
                      Meal, seat, Rescheduling & Cancellation are
                      chargeable.(More)
                    </Typography>
                    <Typography
                      sx={{
                        color: "#BC0000",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Open Sans",
                      }}
                    >
                      N
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default MultiCity;
